import { z } from 'zod';

export const deleteRecommendationSchema = z.object({
  recommendation_id: z.string().min(1, 'Recommendation ID is required'),
});

export type DeleteRecommendationPayload = z.infer<typeof deleteRecommendationSchema>;
